var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObservatorioWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Observatorio_white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 268.832,
    height: 208.07,
    viewBox: "0 0 268.832 208.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff8f2;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_516",
    "data-name": "Rectangle 516",
    className: "cls-1",
    width: 268.832,
    height: 208.07
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    className: "cls-1",
    d: "M141.166,208.071a4.91,4.91,0,0,1-4.91-4.91V161.815L114.745,199.46a4.91,4.91,0,1,1-8.527-4.872l24.551-42.964a4.91,4.91,0,0,1,4.263-2.474h1.224V121.827l-18.048,6.188a4.91,4.91,0,0,1-3.185-9.289l21.483-7.365.1-.032,15.344-4.908a4.91,4.91,0,1,1,2.993,9.353l-8.863,2.836V149.15H147.3a4.91,4.91,0,0,1,4.263,2.474l24.551,42.964a4.911,4.911,0,0,1-8.527,4.872l-21.517-37.654v41.356a4.909,4.909,0,0,1-4.91,4.91M14.118,136.258A4.91,4.91,0,0,1,9.45,132.87L.243,104.637A4.91,4.91,0,0,1,3.377,98.45L45.718,84.522l-.653-1.932a4.91,4.91,0,0,1,3.089-6.228l85.928-28.848a4.91,4.91,0,0,1,3.125,9.31L55.945,84.106l10.97,32.436L187.722,76.083,176.74,43.611,154.965,50.7a4.91,4.91,0,0,1-3.04-9.338l26.391-8.592a4.907,4.907,0,0,1,6.171,3.1L198.6,77.6a4.908,4.908,0,0,1-3.092,6.229L65.391,127.409a4.911,4.911,0,0,1-6.211-3.083l-.8-2.368L15.652,136.012a4.907,4.907,0,0,1-1.534.246m-3.02-30.01,6.162,18.9L54.578,112.87l-6.163-18.9ZM211.135,82.86a4.912,4.912,0,0,1-4.65-3.341L189.3,28.576a4.91,4.91,0,0,1,2.735-6.09l20.255-8.593a4.91,4.91,0,0,1,3.835,9.041L200.06,29.749l14.306,42.408,43.193-10.046L240.733,11.638l-1.785.812a4.91,4.91,0,0,1-4.065-8.94l6.751-3.07a4.911,4.911,0,0,1,6.691,2.917L268.58,64.12a4.91,4.91,0,0,1-3.546,6.335L212.25,82.732a4.908,4.908,0,0,1-1.115.128",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObservatorioWhite);
export default __webpack_public_path__ + "static/media/Observatorio_white.9501c466d60af643bf8b555fe53e9a78.svg";
export { ForwardRef as ReactComponent };